import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconCollapseHorizontal$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCollapseHorizontal extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'f76fdf213b282540d62fbaf214a0e9f6574d5789', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'e2a03e8477fca705dbe7605097fd5cfc2bb1a44b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '1030f3088961df8b38a91f9c69d8b166fe29710c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M17.613 13.87c.346.294.887.056.887-.388V8.518c0-.444-.541-.682-.887-.389l-2.93 2.482a.506.506 0 0 0 0 .778zM11.25 3a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 .5-.5zM3.5 8.518c0-.444.541-.682.887-.389l2.93 2.482a.507.507 0 0 1 0 .778l-2.93 2.482c-.346.293-.887.055-.887-.39z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-collapse-horizontal", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-collapse-horizontal"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-collapse-horizontal":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCollapseHorizontal$1);
            }
            break;
    } });
}

const CosmosIconCollapseHorizontal = CosmosIconCollapseHorizontal$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCollapseHorizontal, defineCustomElement };
